import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { updateMeasurmentSheetStatusApi } from "../../../../../services/DocumentService";
import { connect } from "react-redux";

const VersionStatus = ({ item, handleAfterUpdate, userPermission }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const handleModalOpen = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedStatus("");
    setRemark(""); 
  };

  useEffect(() => {
    if (showModal) {
      if (item?.status === "pending") {
        setSelectedStatus("review");
      } else if (item?.status === "reviewed") {
        setSelectedStatus("approved");
      } else if (item?.status === "approved") {
        setSelectedStatus("issued");
      }
    }
  }, [showModal, item?.status]);

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitLoading(true);

      const data = {
        id: item.id,
        status: selectedStatus,
        remarks: remark,
      };
      const response = await updateMeasurmentSheetStatusApi(item.id , data);
      handleAfterUpdate(response.data.results);
      toast.success(response.data.message);
      handleModalClose();
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      {item?.status === "draft" ? (
        <span className="badge light border-0 badge-secondary badge-sm">
          Draft
        </span>
      ) : item?.status === "pending" ? (
        <span
          className={`badge light border-0 badge-warning badge-sm ${
            userPermission?.review ? "cursor-pointer" : ""
          }`}
          onClick={userPermission?.review ? handleModalOpen : undefined}
        >
          Pending
        </span>
      ) : item?.status === "issued" ? (
        <span className="badge light border-0 badge-primary badge-sm">
          Issued
        </span>
      ) : item?.status === "reviewed" ? (
        <span
          className={`badge light border-0 badge-info badge-sm ${
            userPermission?.approve ? "cursor-pointer" : ""
          }`}
          onClick={userPermission?.approve ? handleModalOpen : undefined}
        >
          Reviewed
        </span>
      ) : item?.status === "rejected" ? (
        <span className="badge light border-0 badge-danger badge-sm">
          Rejected
        </span>
      ) : (
        <span
          className={`badge light border-0 badge-info badge-sm ${
            userPermission?.issue ? "cursor-pointer" : ""
          }`}
          onClick={userPermission?.issue ? handleModalOpen : undefined}
        >
          Approved
        </span>
      )}

      <Modal show={showModal} centered={true} onHide={handleModalClose}>
        <div className="modal-content">
          <div className="modal-body">
            <Form onSubmit={(e) => e.preventDefault()}>
              <Form.Group className="mb-3">
                <Form.Label>Select Status:</Form.Label>
                <div className="d-flex align-items-center">
                  {item?.status === "pending" && (
                    <Form.Check
                      type="radio"
                      id="review"
                      label="Review"
                      name="status"
                      value="reviewed"
                      checked
                      onChange={handleStatusChange}
                    />
                  )}
                  {item?.status === "reviewed" && (
                    <Form.Check
                      type="radio"
                      id="approved"
                      label="Approve"
                      name="status"
                      value="approved"
                      checked
                      onChange={handleStatusChange}
                    />
                  )}
                  {item?.status === "approved" && (
                    <Form.Check
                      type="radio"
                      id="issued"
                      label="Issued"
                      name="status"
                      value="issued"
                      checked
                      onChange={handleStatusChange}
                    />
                  )}
                </div>
              </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Remark:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={remark}
                    onChange={handleRemarkChange}
                    placeholder="Enter your remark here"
                  />
                </Form.Group>

              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary me-3"
                  disabled={isSubmitLoading}
                  onClick={handleSubmit}
                >
                  {isSubmitLoading ? "Updating..." : "Update"}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  userPermission: state.auth.user?.test_evaluation_permission,
});
export default connect(mapStateToProps)(VersionStatus);
